import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import UploadIcon from "@mui/icons-material/Upload";

const Input = styled("input")({
	display: "none",
});

const DocumentCard = ({
	image,
	title,
	subtitle,
	fileSize,
	buttonText,
	name,
	handleChange,
	displayRequired = "true",
}) => {
	return (
		<Box
			sx={{
				display: "flex",
				border: "1px solid #e2e8f0",
				padding: "1rem",
				color: "#1a202c",
				mb: "1.5rem",
				"&:last-child": {
					mb: 0,
				},
			}}
		>
			{image && (
				<Box
					sx={{
						height: "8rem",
						width: "8rem",
						paddingRight: "1rem",
					}}
				>
					<img
						src={image}
						alt=""
						height="100%"
						width="100%"
						style={{ objectFit: "cover" }}
					/>
				</Box>
			)}
			<Box>
				<Typography
					variant="body1"
					sx={{ fontWeight: "bold", textTransform: "capitalize" }}
					gutterBottom
				>
					{title} {displayRequired && "*"}
				</Typography>
				{subtitle && (
					<Typography
						variant="body2"
						sx={{ textTransform: "capitalize", color: "#718096" }}
						gutterBottom
					>
						{subtitle}
					</Typography>
				)}
				{fileSize && (
					<Typography variant="body2" gutterBottom>
						File Size:{" "}
						{fileSize > 1000000
							? `${(fileSize / 1000000).toFixed(1)}mb`
							: `${Math.round(fileSize / 1000)}kb`}
					</Typography>
				)}
				<label htmlFor={`contained-button-file-${name}`}>
					<Input
						accept="image/*"
						id={`contained-button-file-${name}`}
						type="file"
						name={name}
						onChange={handleChange}
					/>
					<Button
						variant="outlined"
						sx={{ mt: "1rem" }}
						component="span"
						endIcon={<UploadIcon />}
					>
						{buttonText}
					</Button>
				</label>
			</Box>
		</Box>
	);
};

export default DocumentCard;
